/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Switch from "react-switch";

import {
  setInsightsCriteriaOrganisation,
  setInsightsCriteriaType,
  setInsightsCriteriaBoundaries,
  setInsightsCriteriaPoi,
  setInsightsCriteriaMobileApps,
  clearInsightsCriteriaPois,
  clearInsightsCriteriaMobileApps,
  toggleStatisticDisplay,
} from '../store/actions/criteria-actions';
import {
  fetchRegionalAreaData,
  fetchBoundaries,
  fetchPois,
  fetchMobileAppsList,
} from '../store/actions/location-actions';

import {
  MultiValueLabel,
  formatOptionsLabel,
  checkDefaultTab,
  isBoundariesBeMultiSelect
} from '../utilities/report-helpers';

import { searchStringInObjectArray } from '../utilities/helpers';

import SVGIcon from '../components/SVGIcon';

const mapStateToProps = (
  { home, insightsCriteria, locations, reports, client, pois, mobileAppsList },
  ownProps
) => ({
  ...home,
  organisations:
    reports.reportDictionary &&
      reports.reportDictionary[ownProps.reportId] &&
      Array.isArray(reports.reportDictionary[ownProps.reportId].organisation)
      ? reports.reportDictionary[ownProps.reportId].organisation
      : [],
  ...insightsCriteria,
  boundariesDataLoaded: locations.boundariesDataLoaded,
  boundariesDictionary: locations.boundariesDictionary,
  ...pois,
  ...mobileAppsList,
  tiers:
    reports.reportDictionary &&
      reports.reportDictionary[ownProps.reportId] &&
      Array.isArray(reports.reportDictionary[ownProps.reportId].tiers)
      ? reports.reportDictionary[ownProps.reportId].tiers
      : [],
  organisationsAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].organisationsAvailable,
  report: reports.reportDictionary[ownProps.reportId],
  geographyAvailable:
    reports.reportDictionary &&
    reports.reportDictionary[ownProps.reportId] &&
    reports.reportDictionary[ownProps.reportId].geographyAvailable,
  country: client.country,
  clinetID: client.id
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setInsightsCriteriaOrganisation,
      fetchRegionalAreaData,
      fetchBoundaries,
      fetchPois,
      fetchMobileAppsList,
      setInsightsCriteriaType,
      setInsightsCriteriaBoundaries,
      setInsightsCriteriaPoi,
      setInsightsCriteriaMobileApps,
      clearInsightsCriteriaPois,
      clearInsightsCriteriaMobileApps,
      toggleStatisticDisplay
    },
    dispatch
  );


class HomeInsightSidebar extends React.Component {
  state = {
    selectedTab: checkDefaultTab(this.props.reportsType, this.props.insightType, this.props.geographyAvailable, this.props.organisationsAvailable),
    organisation: null,
    regionalArea: null,
    pageUrl: null,
    adm0: null,
    adm1: null,
    adm2: null,
    adm3: this.props.clientID === '5c582f6bf49491ca3dd9afac'
          ? [{label: "Auckland, Auckland", value: "17805434030167391015"}]
          : null,
    adm4: null,
    poiId: null,
    mobileApp: null,
    baseline: { label: `Country`, value: `country` },
    attribute:
    this.props.organisation !== null &&
    this.props.organisation.organisationType === 'digital'
      ? {
        label: `Mobile App`,
        value: `mobile-app`
      }
      : {
        label: `Footfall`,
        value: `footfall`
      },
  };

  componentDidMount() {
      this.props.fetchBoundaries();
      this.state.selectedTab === 'organisation' && this.props.fetchPois();
      (this.props.report.props.showAppsDropdown &&
      this.props.report.props.showAppsDropdown === true ) && this.props.fetchMobileAppsList()

    this.setStateValues();
  }

  componentDidUpdate(prevProps) {

    if (this.props.criteriaId !== prevProps.criteriaId) {
      this.setStateValues();
    }
  }

  setStateValues = () => {

    let selectedTab = checkDefaultTab(this.props.reportsType, this.props.insightType, this.props.geographyAvailable, this.props.organisationsAvailable)

    // Get the url now
    const pageUrl = window.location.pathname;

    this.setState(() => ({
      selectedTab,
      organisation: this.props.organisation,
      pageUrl,
      adm0:
        this.props.adm1 === null && this.props.adm2 === null && this.props.adm3 === null && this.props.adm4 === null && selectedTab === 'geography'
          ?
          this.props.country !== null && this.props.country === 'NZ'
            ?
            [{ label: `New Zealand`, level: 'adm0', value: `New Zealand` }]
            :
            [{ label: `Australia`, level: 'adm0', value: `Australia` }]
          : this.props.adm0,
      adm1: this.props.adm1,
      adm2: this.props.adm2,
      adm3: this.props.adm3,
      adm4: this.props.adm4,
      poiId: this.props.poiId,
      mobileApp: this.props.mobileApp,
    }));


  };

  setOrganisation = event => {

    this.setState(() => ({ organisation: event }));

    if(event !== null ){
      this.setState({ attribute: event.organisationType === 'digital'
      ? {
        label: `Mobile App`,
        value: `mobile-app`
      }
      : {
        label: `Footfall`,
        value: `footfall`
      }, });
    }

    /*
      There are 3 things will do in pois select button after user select another organisation:
        1. set new CriteriaOrganisation for fetch new organisation pois.
        2. clear current pois data
        3. get new organisation data.
    */
    this.props.setInsightsCriteriaOrganisation(
      event,
      event !== null
        ? event.subcategory
        : null
    );
    this.props.clearInsightsCriteriaPois();
    this.props.clearInsightsCriteriaMobileApps();
    // pois api call
    event !== null && (this.props.fetchPois());
    // mobile app api call
    ( event !== null &&
      this.props.report.props.showAppsDropdown &&
      this.props.report.props.showAppsDropdown === true ) && (this.props.fetchMobileAppsList());

      this.props.loadData('organisation')
  };

  notSet = tier => tier === null || (Array.isArray(tier) && tier.length === 0);

  setPoi = event => this.setState(() => ({ poiId: event, baseline: { label: `Country`, value: `country` } }));

  setMobileApp = event => this.setState(() => ({ mobileApp: event }));

  setTier = (event, tier) => {
    const notSet = this.notSet;
    if(event !== null && Array.isArray(event) === false) { // All boundaries is single seleciton -> make it as array
        event = [event]
    }

    // if select all boundaries -> return all.
    if(event !== null && tier === "adm2" && searchStringInObjectArray("All Regional", event, "label") ){
      this.setState(() => ({ adm2: [event[event.length -1]] }) );
    }else if(event !== null && tier === "adm3" && searchStringInObjectArray("All Metro", event, "label")){
      this.setState(() => ({ adm3: [event[event.length -1]] }) );
    }else{
      this.setState(() => ({ [tier]: event }));
    }


    if (!(notSet(this.state.adm0) && notSet(this.state.adm1) && notSet(this.state.adm2) && notSet(this.state.adm3) && notSet(this.state.adm4))) {
      this.setState(() => ({ baseline: { label: `Country`, value: `country` } }));
    }

  }
  setCountry = event => this.setState(() => ({ adm0: event }));

  handleResetFilters = () =>
    this.setState(() => ({
      organisation: null,
      regionalArea: null,
      adm0: null,
      adm1: null,
      adm2: null,
      adm3: null,
      adm4: null,
      poiId: null,
      mobileApp: null,
    }));

  handleTabChange = index =>
    this.setState(() => ({
      selectedTab: index === 0 ? 'geography' : 'organisation',
    }));

  handleSearch = () => {
    if (this.state.selectedTab === 'geography') {
      this.props.setInsightsCriteriaType('geography');

    } else if (this.state.selectedTab === 'organisation') {

      this.props.setInsightsCriteriaType('organisation');
      this.props.setInsightsCriteriaOrganisation(
        this.state.organisation
      );
    }

    this.props.setInsightsCriteriaBoundaries({
      adm0:
        Array.isArray(this.state.adm0) && this.state.adm0.length > 0 && this.state.selectedTab === 'geography'
          ? this.state.adm0
          : null,
      adm1:
        Array.isArray(this.state.adm1) && this.state.adm1.length > 0
          ? this.state.adm1
          : null,
      adm2:
        Array.isArray(this.state.adm2) && this.state.adm2.length > 0
          ? this.state.adm2
          : null,
      adm3:
        Array.isArray(this.state.adm3) && this.state.adm3.length > 0
          ? this.state.adm3
          : null,
      adm4:
        Array.isArray(this.state.adm4) && this.state.adm4.length > 0
          ? this.state.adm4
          : null,
      baseline:
        typeof (this.state.baseline) === 'object' && Object.keys(this.state.baseline).length > 0
          ? this.state.baseline
          : null,
      attribute:
      typeof (this.state.attribute) === 'object' && Object.keys(this.state.attribute).length > 0
      ? this.state.attribute
      : null,
    });

    this.state.selectedTab === 'geography'
      ? this.props.setInsightsCriteriaPoi(null)
      : this.props.setInsightsCriteriaPoi(
        Array.isArray(this.state.poiId) && this.state.poiId.length > 0
          ? this.state.poiId
          : null,
      );

    this.state.selectedTab === 'geography'
      ? this.props.setInsightsCriteriaMobileApps(null)
      : this.props.setInsightsCriteriaMobileApps(
        Array.isArray(this.state.mobileApp) && this.state.mobileApp.length > 0
          ? this.state.mobileApp
          : null,
      );

    this.state.selectedTab === 'geography'
      ? this.props.loadData('geography', [this.state.adm2, this.state.adm3, this.state.adm4, this.state.poiId])
      : this.props.loadData('organisation', [this.state.adm2, this.state.adm3, this.state.adm4, this.state.poiId])

  };

  seachButtonEnabled = () => {
    if (this.state.selectedTab === 'organisation') {
      return this.state.organisation === null;
    }
    return this.state.adm0 === null && this.state.adm2 === null && this.state.adm3 === null && this.state.adm4 === null

  };

  boundariesSelectorDisabled = level => {
    const { adm0, adm1, adm2, adm3, adm4, poiId, selectedTab, organisation } = this.state;
    const notSet = this.notSet;

    if (selectedTab === 'geography') {
      switch (level) {
        case 0:
          return !(notSet(adm1) && notSet(adm2) && notSet(adm3) && notSet(adm4));
        case 1:
          return !(notSet(adm0) && notSet(adm2) && notSet(adm3) && notSet(adm4));
        case 2:
          return !(notSet(adm0) && notSet(adm1) && notSet(adm3) && notSet(adm4));
        case 3:
          return !(notSet(adm0) && notSet(adm1) && notSet(adm2) && notSet(adm4));
        case 4:
          return !(notSet(adm0) && notSet(adm1) && notSet(adm2) && notSet(adm3));
        default:
          return false;
      }
    } else if (selectedTab === 'organisation') {

      switch (level) {
        case 1:
            return organisation ? !(notSet(adm2) && notSet(adm3) && notSet(adm4) && notSet(poiId)) : true;
          case 2:
            return organisation ? !(notSet(adm1) && notSet(adm3) && notSet(adm4) && notSet(poiId)) : true;
          case 3:
            return organisation ? !(notSet(adm1) && notSet(adm2) && notSet(adm4) && notSet(poiId)) : true;
          case 4:
            return organisation ? !(notSet(adm1) && notSet(adm2) && notSet(adm3) && notSet(poiId)) : true;
          case 'poiId':
            return organisation ? !(notSet(adm1) && notSet(adm2) && notSet(adm3) && notSet(adm4)) : true;
        default:
          return false;
      }

    }
  };

  placeholderRender = (tier) => {

    if (this.state.selectedTab === 'organisation') {
      if (this.state.organisation !== null) {
        return tier !== undefined && this.boundariesSelectorDisabled(tier.level)
          ? 'Other filter selected'
          : 'Type to search'
      } else {
        return 'Select organisation'
      }
    } else {
      return tier !== undefined && this.boundariesSelectorDisabled(tier.level)
        ? 'Other filter selected'
        : 'Type to search'
    }

  }

  renderTiers = () => {

    return this.props.tiers.map(tierId => {
      const tier = this.props.boundariesDictionary[tierId];

      return (
        <React.Fragment key={tierId}>
          <label htmlFor={`sidebar-select-${tierId}`}>
            {tier.name}
          </label>
          <Select
            inputId={`sidebar-select-${tierId}`}
            className="Sidebar_select"
            classNamePrefix="Sidebar_select_"
            placeholder={this.placeholderRender(tier)}
            isClearable
            isLoading={
              tier === undefined ||
              !this.props.boundariesDataLoaded ||
              this.props.boundariesDictionary[tierId] === undefined
            }
            isDisabled={
              tier === undefined ||
              this.boundariesSelectorDisabled(tier.level) ||
              !this.props.boundariesDataLoaded ||
              this.props.boundariesDictionary[tierId] === undefined
            }
            isRtl={false}
            isSearchable
            name={tierId}
            options={tier === undefined ? [] : tier.options}
            components={{ MultiValueLabel }}
            onChange={e =>
              this.setTier(
                e,
                `adm${tier === undefined ? '' : tier.level}`
              )
            }
            value={
              tier === undefined ? null : this.state[`adm${tier.level}`]
            }
            delimiter=","
            isMulti={ isBoundariesBeMultiSelect(tier.level, this.state[`adm${tier.level}`])  }
          />

        </React.Fragment>
      );
    })
  }

  renderBaseline = () => {
    return (
      <React.Fragment>
        <label htmlFor="country">Baseline</label>
        <Select
          inputId="country"
          className="Sidebar_select"
          classNamePrefix="Sidebar_select_"
          placeholder={
            this.boundariesSelectorDisabled(0)
              ? 'Other filter selected'
              : 'Type to search'
          }
          isDisabled={
            this.notSet(this.state.adm0) &&
            this.notSet(this.state.adm1) &&
            this.notSet(this.state.adm2) &&
            this.notSet(this.state.adm3) &&
            this.notSet(this.state.adm4) &&
            this.notSet(this.state.poiId)
          }
          isLoading={false}
          isRtl={false}
          isSearchable
          name="country"
          delimiter=","
          options={
            [
              {
                label: `Country`,
                value: `country`
              },
              {
                label: `${this.props.boundariesDictionary['district'].name} / ${this.props.boundariesDictionary['city'].name}`,
                value: `place`
              },
            ]
          }
          onChange={e => this.setState({ baseline: e })}
          value={this.state.baseline}
        />
      </React.Fragment>
    )

  }


  brandAffinityPoiView = () => {
    if (this.props.organisation !== undefined && this.props.organisation !== null) {
      const organisationType = this.props.organisation.organisationType;
      /*
        this.props.organisation.organisationType =  " "  ->  always physical
      */

      if (organisationType === 'digital') {
        return (
          <div></div>
        )
      } else {
        return (
          <div>
            <label htmlFor="pois">Points of Interest</label>
            <Select
              inputId="pois"
              className="Sidebar_select"
              classNamePrefix="Sidebar_select_"
              placeholder={
                this.state.organisation !== null
                  ? (this.boundariesSelectorDisabled('poiId')
                    ? 'Other filter selected'
                    : 'Type to search')

                  : 'Select organisation'
              }
              isDisabled={
                this.boundariesSelectorDisabled('poiId') ||
                !this.props.poisDataLoaded
              }
              components={{ MultiValueLabel }}
              formatOptionLabel={formatOptionsLabel}
              isLoading={!this.props.poisDataLoaded}
              isClearable
              isRtl={false}
              isSearchable
              isMulti
              name="pois"
              delimiter=","
              options={this.props.poisData}
              onChange={this.setPoi}
              value={this.state.poiId}
            />
          </div>
        );
      }
    }

  }

  brandAffinityMobileAppview = () => {
    if (this.props.organisation !== undefined && this.props.organisation !== null) {
      const organisationType = this.props.organisation.organisationType;
      /*
        this.props.organisation.organisationType =  " "  ->  always physical
      */
      if (organisationType === "" || organisationType === "physical") {
        return (
          <div></div>
        )
      } else {
        return (<div>
          <label htmlFor="apps">{this.props.report.props.customMobileApplicationsName}</label>
          <Select
            inputId="apps"
            className="Sidebar_select"
            classNamePrefix="Sidebar_select_"
            placeholder={
              this.state.organisation !== null
                ? 'Type to search'
                : 'Select organisation'
            }
            isDisabled={false}
            components={{ MultiValueLabel }}
            formatOptionLabel={formatOptionsLabel}
            isLoading={!this.props.mobileAppsListLoaded}
            isClearable
            isRtl={false}
            isSearchable
            isMulti
            name="apps"
            delimiter=","
            options={this.props.mobileAppsList}
            onChange={this.setMobileApp}
            value={this.state.mobileApp}
          />
        </div>)
      }
    }
  }

  attributeView = () => {
    return (
      <React.Fragment>
        <label htmlFor="attribute">Attribute</label>
        <Select
          inputId="attribute"
          className="Sidebar_select"
          classNamePrefix="Sidebar_select_"
          placeholder={
            this.state.organisation !== null
              ? 'Type to search'
              : 'Select organisation'
          }
          isDisabled={
            this.props.organisation === null ||
            this.props.organisation.organisationType !== 'phygital'
          }
          isClearable={false}
          isLoading={false}
          isRtl={false}
          isSearchable
          name="attribute"
          delimiter=","
          options={
            [
              {
                label: `Footfall`,
                value: `footfall`
              },
              {
                label: `Mobile App`,
                value: `mobile-app`
              },
            ]
          }
          onChange={e => this.setState({ attribute: e })}
          value={this.state.attribute}
        />
      </React.Fragment>
    )
  }

  handleDisplayStatistic = () => {
    this.props.toggleStatisticDisplay();
  }


  render() {
    const tiersView = this.renderTiers();
    const baselineView = this.renderBaseline();
    return (
      <div className="Sidebar" >
        <button
          onClick={this.props.toggleSideBar}
          className="Sidebar_close-button"
        >
          <SVGIcon icon="back-arrow" />
        </button>
        <Tabs
          selectedTabClassName="Sidebar_tab_selected"
          defaultIndex={this.state.selectedTab === 'organisation' ? 1 : 0}
          onSelect={this.handleTabChange}
        >

          <TabList className="Sidebar_tab-list">
            <Tab
              className="Sidebar_tab"
              disabled={!this.props.geographyAvailable}
            >
              Geography
            </Tab>
            <Tab
              className="Sidebar_tab"
              disabled={!this.props.organisationsAvailable}
            >
              Organisation
            </Tab>
          </TabList>

          <TabPanel> {/* Geograhy tab view */}
            <div className="Sidebar_tab-panel">
              <div>
                <label htmlFor="country">Country</label>
                <Select
                  inputId="country"
                  className="Sidebar_select"
                  classNamePrefix="Sidebar_select_"
                  placeholder={
                    this.boundariesSelectorDisabled(0)
                      ? 'Other filter selected'
                      : 'Type to search'
                  }
                  isDisabled={this.boundariesSelectorDisabled(0)}
                  isLoading={false}
                  isClearable
                  isRtl={false}
                  isSearchable
                  isMulti
                  name="country"
                  delimiter=","
                  options={
                    this.props.country !== null && this.props.country === 'NZ'
                      ?
                      [{ label: `New Zealand`, level: 'adm0', value: `New Zealand` }]
                      :
                      [{ label: `Australia`, level: 'adm0', value: `Australia` }]
                  }
                  onChange={this.setCountry}
                  value={this.state.adm0}
                />
              </div>
            </div>

            <div className="Sidebar_location-select-wrapper">
              {
                this.props.reportsType === 'brandAffinity' && baselineView
              }
              {tiersView}
            </div>

          </TabPanel>

          <TabPanel> {/* Organisation tab view */}
            <div className="Sidebar_tab-panel">
              <label htmlFor="organisation">Organisation</label>
              <Select
                inputId="organisation"
                className="Sidebar_select"
                classNamePrefix="Sidebar_select_organisation_"
                placeholder="Type to search"
                isDisabled={false}
                isLoading={false}
                isClearable={false}
                isRtl={false}
                isSearchable
                name="organisation"
                options={this.props.organisations}
                onChange={this.setOrganisation}
                value={this.state.organisation}
              />
            </div>

            <div className="Sidebar_location-select-wrapper">

              {  // remove for now. #349 comment.
                //this.props.reportsType === 'brandAffinity' && this.attributeView()
              }

              {
                this.props.reportsType === 'brandAffinity' && baselineView
              }

              {
                this.props.report.props.showAppsDropdown &&
                  this.props.report.props.showAppsDropdown === true
                  ? this.props.reportsType === 'brandAffinity'
                    ? this.brandAffinityMobileAppview()
                    : (<div></div>)
                  : (<div></div>)
              }

              {tiersView}

              {
                this.props.report.props.showPOIsDropdown &&
                  this.props.report.props.showPOIsDropdown === true
                  ? this.props.reportsType === 'brandAffinity'
                    ? this.brandAffinityPoiView()
                    : (
                      <div>
                        <label htmlFor="pois">Points of Interest</label>
                        <Select
                          inputId="pois"
                          className="Sidebar_select"
                          classNamePrefix="Sidebar_select_"
                          placeholder={
                            this.state.organisation !== null
                              ? (this.boundariesSelectorDisabled('poiId')
                                ? 'Other filter selected'
                                : 'Type to search')

                              : 'Select organisation'
                          }
                          isDisabled={
                            this.boundariesSelectorDisabled('poiId') ||
                            !this.props.poisDataLoaded
                          }
                          components={{ MultiValueLabel }}
                          formatOptionLabel={formatOptionsLabel}
                          isLoading={!this.props.poisDataLoaded}
                          isClearable
                          isRtl={false}
                          isSearchable
                          isMulti
                          name="pois"
                          delimiter=","
                          options={this.props.poisData}
                          onChange={this.setPoi}
                          value={this.state.poiId}
                        />
                      </div>
                    )
                  : (<div></div>)
              }

            </div>
          </TabPanel>

        </Tabs>

        {this.props.reportsType === 'brandAffinity' && (
          <div className="Sidebar_statistic-toggle">
            <span>Display statistic value</span>
            <Switch
              checked={this.props.isStatisticDisplay}
              onChange={this.handleDisplayStatistic}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={25}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={15}
              width={40}
              className="Sidebar_statistic-toggle_react-switch"
              id="material-switch"
            />
          </div>
        )}


        <div className="Sidebar_confirm-reset">
          <button
            className="Sidebar_reset-button"
            onClick={this.handleResetFilters}
          >
            Reset filters
          </button>
          <button
            className="Sidebar_confirm-button"
            onClick={this.handleSearch}
            disabled={this.seachButtonEnabled()}
          >
            Confirm
          </button>
        </div>
      </div>
    );
  }
}

HomeInsightSidebar.propTypes = {
  organisations: PropTypes.arrayOf(PropTypes.object).isRequired,
  boundariesDataLoaded: PropTypes.bool.isRequired,
  boundariesDictionary: PropTypes.object, // eslint-disable-line
  report: PropTypes.object, // eslint-disable-line
  tiers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setInsightsCriteriaBoundaries: PropTypes.func.isRequired,
  setInsightsCriteriaPoi: PropTypes.func.isRequired,
  setInsightsCriteriaType: PropTypes.func.isRequired,
  organisation: PropTypes.object, // eslint-disable-line
  setInsightsCriteriaOrganisation: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired,
  insightType: PropTypes.string,
  organisationsAvailable: PropTypes.bool.isRequired,
  fetchBoundaries: PropTypes.func.isRequired,
  fetchPois: PropTypes.func.isRequired,
  country: PropTypes.string.isRequired,
  criteriaId: PropTypes.string.isRequired,
  adm1: PropTypes.arrayOf(PropTypes.object),
  adm2: PropTypes.arrayOf(PropTypes.object),
  adm3: PropTypes.arrayOf(PropTypes.object),
  adm4: PropTypes.arrayOf(PropTypes.object),
};

HomeInsightSidebar.defaultProps = {
  organisation: null,
  insightType: null,
  adm1: null,
  adm2: null,
  adm3: null,
  adm4: null,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeInsightSidebar);
